import React, { useState, useCallback, useEffect, useRef } from 'react';
import moment from 'moment';
import Filter from '@/pages/intelligence/components/Filter';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';

export default function ActiveuserDetailFilter(props: any) {
  const {
    filterConfirm,
    filterReset,
    filterInit,
    buttonLogConfig,
    iconText,
    timeFilterValues,
    isCalibrated,
    isTopCompanies = false,
    onFilterInit,
    showSelectType = true,
  } = props;
  const defaultValue = {
    [filterKeyMap.REGION]: {
      regions: [],
      markets: ['global'],
      type: 'market',
    },
    // [filterKeyMap.DATASOURCESIM]: {
    //   value: isCalibrated ? 'ogdb' : 'appannie',
    // },
    [filterKeyMap.RANGE_TIME]: {
      type: showSelectType ? 'date' : 'month',
      value: ['', ''],
    },
    [filterKeyMap.DATASOURCESIM]: {
      value: 'sensortower',
    },
  };
  // 继承逻辑在这写
  // formValue改成用ref，可提供给父组件回填时间， 或添加继承逻辑提供formValue给父组件
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const extendDefaultValue = !isOperateDetail
    ? defaultValue
    : {
        [filterKeyMap.RANGE_TIME]: {
          type:
            detailFilterExtend[filterKeyMap.RANGE_TIME]?.filterType ??
            defaultValue[filterKeyMap.RANGE_TIME]?.type,
          value:
            detailFilterExtend[filterKeyMap.RANGE_TIME]?.filterValue ??
            defaultValue[filterKeyMap.RANGE_TIME]?.value,
        },
        [filterKeyMap.REGION]: {
          regions:
            detailFilterExtend[filterKeyMap.REGION]?.filterRegions ??
            defaultValue[filterKeyMap.REGION]?.regions,
          markets:
            detailFilterExtend[filterKeyMap.REGION]?.filterMarkets ??
            defaultValue[filterKeyMap.REGION]?.markets,
          type:
            detailFilterExtend[filterKeyMap.REGION]?.filterType ??
            defaultValue[filterKeyMap.REGION]?.type,
        },
        // [filterKeyMap.DATASOURCESIM]: {
        //   value:
        //     detailFilterExtend[filterKeyMap.DATASOURCESIM]?.value ??
        //     defaultValue[filterKeyMap.DATASOURCESIM]?.value,
        // },
        [filterKeyMap.DATASOURCESIM]: {
          value: 'sensortower',
        },
      };

  const [formValue, setFormValue] = useState(extendDefaultValue);

  const updateInputLists = [
    {
      type: filterKeyMap.RANGE_TIME,
      key: filterKeyMap.RANGE_TIME,
      calendarType: showSelectType ? 'date' : 'month',
      typeList: showSelectType ? ['date', 'week', 'month'] : ['month'],
      showSelectType: false,
    },
    {
      key: filterKeyMap.REGION,
      default: defaultValue[filterKeyMap.REGION],
      visible: 1,
      options: [],
      isTopCompanies,
    },
    {
      key: filterKeyMap.DATASOURCESIM,
      default: [],
      singleType: 'single',
      isSearchItemMargin: true,
      isShowButtonLabel: true,
    },
    // {
    //   key: filterKeyMap.DATASOURCESIM,
    //   default: defaultValue[filterKeyMap.DATASOURCESIM],
    //   showDatabrain: isCalibrated,
    // },
  ];

  const updateInputList = (isCalibrated: boolean) => {
    return [
      {
        type: filterKeyMap.RANGE_TIME,
        key: filterKeyMap.RANGE_TIME,
        calendarType: showSelectType ? 'date' : 'month',
        typeList: showSelectType ? ['date', 'week', 'month'] : ['month'],
        showSelectType: !showSelectType,
      },
      {
        key: filterKeyMap.REGION,
        default: defaultValue[filterKeyMap.REGION],
        visible: 1,
        options: [],
        isTopCompanies,
      },
      {
        key: filterKeyMap.DATASOURCESIM,
        default: [],
        singleType: 'single',
        isSearchItemMargin: true,
        isShowButtonLabel: true,
      },
      // {
      //   key: filterKeyMap.DATASOURCESIM,
      //   default: defaultValue[filterKeyMap.DATASOURCESIM],
      //   showDatabrain: isCalibrated,
      // },
    ];
  };
  const [inputList, setInputList] = useState(updateInputList(isCalibrated));
  /** 校准值变化 ，更新筛选器值 */
  useEffect(() => {
    setInputList(updateInputLists);
    setFormValue(extendDefaultValue);
  }, [isCalibrated]);
  /** 优化TODO：这一整块及inputList里的国家参数都放到model里 */
  const { filterLoading, regionOptions } = useMarketFilterApi({});

  useEffect(() => {
    if (onFilterInit instanceof Function) {
      onFilterInit({
        loading: filterLoading,
        regionOptions,
      });
    }
  }, [filterLoading, regionOptions]);

  useEffect(() => {
    /** 国家筛选器的列表值 */
    if (regionOptions) {
      const inputListTmp = [...inputList];
      const regionIndex = inputList?.findIndex((item) => {
        return item?.key === filterKeyMap.REGION;
      });
      if (regionIndex !== -1) {
        inputListTmp[regionIndex].options = regionOptions;
        setInputList(inputListTmp);
      }
    }
  }, [regionOptions]);

  /** 时间筛选器值由父组件更新 */
  useEffect(() => {
    if (Array.isArray(timeFilterValues?.value) && timeFilterValues?.value.length === 2) {
      const newFormValue = {
        ...formValue,
        [filterKeyMap.RANGE_TIME]: {
          type: feachTimeTypeToFilterTimeType(timeFilterValues.type), // TODO
          value: [moment(timeFilterValues.value[0]), moment(timeFilterValues.value[1])],
        },
      };
      setFormValue(newFormValue);
    }
  }, [JSON.stringify(timeFilterValues)]);

  const onConfirm = useCallback(
    (value /** 筛选器数据 */, apiValue /** 筛选器转换后的数据 */) => {
      setFormValue(value);
      const filterForm = {
        region_type: apiValue[filterKeyMap.REGION]?.region_type, // 默认都是market
        regions: apiValue[filterKeyMap.REGION]?.regions,
        period: apiValue[filterKeyMap.RANGE_TIME]?.granularity,
        start_date: apiValue[filterKeyMap.RANGE_TIME]?.start_date,
        end_date: apiValue[filterKeyMap.RANGE_TIME]?.end_date,

        source: value[filterKeyMap.DATASOURCESIM]?.value,
      };
      filterConfirm(filterForm);
      setDetailFilterExtend(apiValue);
    },
    [filterConfirm],
  );

  return (
    <Filter
      value={formValue}
      inputList={inputList}
      // onInit={onInit}
      onConfirm={onConfirm}
      onReset={() => {}}
      showButton={false}
    />
  );
}
